export default __webpack_public_path__ + "static/1504-0a1df1a5f8372a6162c431c3acec7dcb.gif";